import axios from "axios";

const API = "http://129.153.124.232:3000/api/auth";

export const login = (username, password) =>
  axios.post(`${API}/login`, { username, password });

export const register = (data) =>
  axios.post(`${API}/register`, data);
